export default __webpack_public_path__ + "images/0e09db3562363423aff11f6a49a8c966.png";